import { motion } from "framer-motion";
import { Check } from "lucide-react";

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressIndicator = ({ currentStep, totalSteps }: ProgressIndicatorProps) => {
  // Don't show progress on the success step
  if (currentStep === totalSteps) return null;

  return (
    <div className="flex items-center justify-center gap-2 mb-8">
      {Array.from({ length: totalSteps - 1 }).map((_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;

        return (
          <div key={stepNumber} className="flex items-center">
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ 
                scale: isCurrent ? 1.1 : 1,
                backgroundColor: isCompleted 
                  ? "hsl(var(--primary))" 
                  : isCurrent 
                    ? "hsl(var(--primary) / 0.2)" 
                    : "hsl(var(--muted))"
              }}
              className={`
                w-3 h-3 rounded-full flex items-center justify-center
                ${isCurrent ? "ring-2 ring-primary ring-offset-2 ring-offset-background" : ""}
              `}
            >
              {isCompleted && (
                <Check className="w-2 h-2 text-primary-foreground" />
              )}
            </motion.div>
            {index < totalSteps - 2 && (
              <div 
                className={`w-8 h-0.5 mx-1 transition-colors duration-300 ${
                  isCompleted ? "bg-primary" : "bg-muted"
                }`} 
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressIndicator;
